import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

export type userConfirm = 'Confirm' | 'Denied';
export type paymentMethod = 'CREDIT_CARD' | 'PIX';
export type responseModal = {
  confirm: boolean;
  method?: paymentMethod;
};
export type amountRequest = {
  totalAmount: number;
};
@Component({
  selector: 'app-wallet-modal',
  templateUrl: './wallet-modal.component.html',
  styleUrls: ['./wallet-modal.component.scss'],
})
export class WalletModalComponent {
  private readonly userResponseSubject = new Subject<responseModal>();
  readonly response$ = this.userResponseSubject.asObservable();

  method?: paymentMethod;
  selectPayment: boolean = false;

  constructor(
    public dialog: MatDialogRef<WalletModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: amountRequest
  ) {}

  paymentMethod(method: paymentMethod) {
    this.method = method;
    this.selectPayment = false;
  }

  onDeny() {
    this.userResponseSubject.next({ confirm: false });
    this.dialog.close();
  }

  onConfirm() {
    if (!this.method) {
      this.selectPayment = true;
      return;
    }
    this.userResponseSubject.next({ confirm: true, method: this.method });
    this.dialog.close();
  }
}
